var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6780",
    "data-name": "Rectangle 6780",
    width: 24,
    height: 24,
    fill: "#292929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_109",
    "data-name": "Mask Group 109",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_003-message",
    "data-name": "003-message",
    d: "M21.414.055H2.586A2.589,2.589,0,0,0,0,2.641V18.456a2.589,2.589,0,0,0,2.586,2.586H21.414A2.589,2.589,0,0,0,24,18.456V2.641A2.589,2.589,0,0,0,21.414.055Zm0,1.406a1.166,1.166,0,0,1,.172.013l-8.752,8.752a1.181,1.181,0,0,1-1.668,0L2.413,1.474a1.167,1.167,0,0,1,.173-.013Zm1.18,17a1.181,1.181,0,0,1-1.18,1.18H2.586a1.181,1.181,0,0,1-1.18-1.18V2.641a1.192,1.192,0,0,1,.013-.173l8.753,8.752a2.589,2.589,0,0,0,3.657,0l8.753-8.752a1.194,1.194,0,0,1,.013.173Zm0,0",
    transform: "translate(0 1.452)",
    fill: "#292929"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contact_email.26b6be5551cb7ea0f3708a0438af2087.svg";
export { ForwardRef as ReactComponent };